import { ScorecardLicenseRenewalResult } from "../../../../Component/Model/Dto/ScorecardLicenseExpiry/ScorecardLicenseExpiry";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Link, List, ListItem, Typography } from "@mui/material";
import { MDTypography } from "../../../../Component/Common/Components/MDTypography";
import colors from "../../../../assets/theme/base/colors";

const { primary } = colors;

interface IProps {
    username: string;
    renewalResult: ScorecardLicenseRenewalResult;
    open: boolean;
    close: () => void;
}

export const ScorecardLicenseRenewalModal = (props: IProps) => {
    return (
        <>
            <Dialog
                open={props.open}
                onClose={() => { }}
                aria-labelledby="information-dialog-title"
                maxWidth='md'
            >
                <DialogTitle>
                    <Grid container paddingLeft={2} paddingTop={1}>
                        <MDTypography variant='body1' fontWeight='bold' color={primary.main}>Your scorecard license has been renewed!</MDTypography>
                    </Grid>
                </DialogTitle>

                <DialogContent sx={{ padding: '20px' }}>
                    <Grid container spacing={2} paddingLeft={2} paddingRight={2}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                            <img
                                src={`${process.env.PUBLIC_URL}/img/LicenseRenewalGift.svg`}
                                style={{ maxWidth: '50%', marginTop: '10px' }}
                            />
                        </div>

                        <Grid item xs={12}>
                            <MDTypography variant='body'>
                                Dear {props.username},
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12}>
                            <MDTypography variant='body'>
                                Thank you for renewing your license with BEE123 and we are happy to add value to your transformation journey.
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} paddingY={2}>
                            <MDTypography variant="body">
                                A new license has been added to your profile. Kindly activate the license and provide the required access
                                to all users or ask your BEE123 Admin Users to do so:
                            </MDTypography>
                            
                            <List sx={{ paddingLeft: '20px', margin: 0, listStyleType: 'disc' }}>
                                {props.renewalResult.adminUsers.map((admin, index) => (
                                    <ListItem key={index} sx={{ display: 'list-item', paddingLeft: 0 }}>
                                        <MDTypography variant="body">
                                            {admin.name} - <Link href={`mailto:${admin.email}`} underline="always" color={primary.main}>{admin.email}</Link>
                                        </MDTypography>
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>

                        <Grid item xs={12}>
                            <MDTypography variant='body'>
                                For any assistance, kindly see instruction options below.
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12}>
                            <MDTypography variant='body'>
                                Please feel free to contact us should you require any assistance:
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12}>
                            <List sx={{ paddingLeft: '20px', margin: 0, listStyleType: 'disc' }}>
                                <ListItem sx={{ display: 'list-item', paddingLeft: 0 }}>
                                    <MDTypography variant='body'>
                                        Support - <Link href="mailto:support@bee123.co.za" color={primary.main}>support@bee123.co.za</Link>
                                    </MDTypography>
                                </ListItem>
                                <ListItem sx={{ display: 'list-item', paddingLeft: 0 }}>
                                    <MDTypography variant='body'>
                                        General - <Link href="mailto:info@bee123.co.za" color={primary.main}>info@bee123.co.za</Link>
                                    </MDTypography>
                                </ListItem>
                                <ListItem sx={{ display: 'list-item', paddingLeft: 0 }}>
                                    <MDTypography variant='body'>
                                        Renewal - <Link href="mailto:renewals@bee123.co.za" color={primary.main}>renewals@bee123.co.za</Link>
                                    </MDTypography>
                                </ListItem>
                                <ListItem sx={{ display: 'list-item', paddingLeft: 0 }}>
                                    <MDTypography variant='body'>
                                        Or call us on: 0861 233 123
                                    </MDTypography>
                                </ListItem>
                            </List>
                        </Grid>

                        <Grid item xs={12}>
                            <MDTypography variant='body'>
                                Kind regards,
                                <br />
                                BEE123
                            </MDTypography>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button
                        variant='contained'
                        onClick={props.close}
                        sx={{
                            margin: '10px',
                            backgroundColor: primary.main,
                            '&:hover': { backgroundColor: primary.main }
                        }}
                    >
                        Got it!
                    </Button>
                </DialogActions>

            </Dialog>
        </>
    )
}